export const rootRoute = '/';
export const homeRoute = '/home';
export const registerStep1Route = '/register';
export const registerStep2Route = '/register/step2';
export const registerStep3Route = '/register/step3';
export const registerPendingRoute = '/register/pending';
export const registerSuccessRoute = '/register/success';
export const registerApprovedRoute = '/register/approved';
export const currentServiceAreasRoute = '/service-areas';
export const pendingServiceAreasRoute = '/service-areas/pending';
export const pendingTheatreListRoute = '/service-areas/pending/theatre-list';
export const currentTheatreListRoute = '/service-areas/theatre-list';
export const workOrdersRoute = '/work-orders';
export const applianceRoute = '/appliances';
export const workOrdersPastRoute = '/work-orders/past';
export const workOrderReportsRoute = '/reports';
export const companySettingsRoute = '/company-settings';
export const calendarRoute = '/calendar';
export const noAccessRoute = '/noAccess';
export const notFoundRoute = '/not-found';
export const notAllowedRoute = '/na';
export const maintenanceRoute = '/maintenance';
